import { render, staticRenderFns } from "./PlanComparisonTable.vue?vue&type=template&id=418c5e80&scoped=true"
import script from "./PlanComparisonTable.vue?vue&type=script&lang=js"
export * from "./PlanComparisonTable.vue?vue&type=script&lang=js"
import style0 from "./PlanComparisonTable.vue?vue&type=style&index=0&id=418c5e80&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c5e80",
  null
  
)

export default component.exports